<template>
  <a-modal
    :visible="visible"
    title="团队模板"
    :width="600"
    :maskClosable="false"
    :destroyOnClose="true"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="模板名称">
        <a-input
          v-decorator="[
            'title',
            {
              rules: [
                { required: true, message: '请输入模板名称' },
                { max: 20, message: '模板名称不能超过20字' }
              ],
              initialValue: formData.title
            }
          ]"
          placeholder="请输入模板名称"
        />
      </a-form-item>
      <a-form-item label="模板内容">
        <a-textarea
          v-decorator="[
            'content',
            {
              rules: [
                { required: true, message: '请输入模板内容' },
                { max: 1000, message: '模板内容不能超过1000字' }
              ],
              initialValue: formData.content
            }
          ]"
          :rows="6"
          placeholder="请输入模板内容，可以是预设的问题或指令"
        />
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'TeamTemplateModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({
        title: '',
        content: ''
      })
    }
  },
  data() {
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    // 提交表单
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) return
        this.$emit('submit', values)
      })
    },
    // 取消
    handleCancel() {
      this.form.resetFields()
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
